export const isNotNull = (value: string | number | null | undefined) => {
	if (value === null || value === undefined || value === "") return 0;
	return Number(value) || 0;
};

export function formatWithCommas(value: string | number | null) {
	if (value === null || value === "" || value === undefined) return "";
	return isNotNull(value)
		.toString()
		.replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
}

export function formatCurrencyInIndian(value: string | number | null): string {
	if (value === null || value === "" || value === undefined) return "";

	const numericString = value.toString().replace(/,/g, "");

	if (!/^-?\d*\.?\d*$/.test(numericString)) return numericString;

	const parts = numericString.split(".");
	let wholeNumber = parts[0];
	const decimal = parts.length > 1 && parts[1] ? `.${parts[1]}` : "";

	const isNegative = wholeNumber.startsWith("-");
	if (isNegative) {
		wholeNumber = wholeNumber.substring(1);
	}

	if (parseFloat(numericString) === 0) {
		return "0";
	}

	let lastThree = wholeNumber.length > 3 ? wholeNumber.slice(-3) : wholeNumber;
	let otherNumbers = wholeNumber.length > 3 ? wholeNumber.slice(0, -3) : "";

	if (otherNumbers !== "") {
		lastThree = "," + lastThree;
	}

	const formatted =
		otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;

	return (isNegative ? "-" : "") + formatted + decimal;
}

export function IndianPriceFormatter(value: string | number | null): string {
	if (value === null || value === "") return "";

	const numberValue = typeof value === "string" ? Number(value) : value;

	if (isNaN(numberValue)) return "";

	return new Intl.NumberFormat("en-IN", {
		style: "currency",
		currency: "INR",
		maximumFractionDigits: 2,
	}).format(numberValue);
}

export function indianPriceFormatter(amount: number | string): string {
	const num = parseFloat(amount.toString());
	if (isNaN(num)) return "Invalid amount";

	const [whole, decimal] = Math.abs(num).toFixed(2).split(".");
	let result = whole
		.toString()
		.split("")
		.reverse()
		.join("")
		.replace(/(\d{2})(?=\d)/g, "$1,")
		.split("")
		.reverse()
		.join("")
		.replace(/^,/, "");

	if (result.length === 1) result = `0${result}`;
	if (decimal) result += `.${decimal}`;

	return `${num < 0 ? "-" : ""}₹${result}`;
}

// Example:
// indianPriceFormatter(123456789.45) // ₹12,34,56,789.45

export const getNumericValue = (value: unknown) => {
	if (typeof value !== "string") {
		return String(value || "").replace(/,/g, "");
	}
	return value.replace(/,/g, "");
};
